export default [
    {
        path: '/call-centre/operator-statuses',
        name: 'pageOperatorStatusesList',
        meta: { title: 'operatorStatuses.listTitle' },
        component: () => import('@/pages/call-centre/operator-statuses'),
    },
]